<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
const props = defineProps({
    modelValue: {
        type: Number,
    },
    error: {
        type: Boolean,
        default: false,
    },
    white: {
        type: Boolean,
        default: false,
    },
})

const isFocused = ref(false);
const id = computed( () => {
    const instance = getCurrentInstance();
    return props.id || instance.parent.props.id || 'formychat-element-' + instance.parent.uid;
})
</script>

<template>
    <textarea @focus="isFocused = true" @blur="isFocused = false" v-model="props.modelValue" 
        class="text-[14px] relative shadow-sm hover:shadow resize-y focus:outline-none border-0 ring-1 ring-gray-200   focus:bg-white focus:ring-[2px] focus:ring-indigo-400 transition w-full px-4 rounded text-gray-700 disabled:opacity-60 disabled:bg-gray-200 disabled:ring-gray-300 placeholder:text-gray-400  placeholder:text-[13px]"
        v-bind="$attrs" :id="id" :class="{'bg-gray-50' : ! props.white, 'bg-white' : props.white}"></textarea>
</template>

<style scoped>
.max-width {
    width: calc(100% - 2px);
}
</style>